import {
	ABSENCE_CREATE_EDIT,
	ABSENCE_CREATE_EDIT_ERROR,
	ABSENCE_CREATE_EDIT_SUCCESS,
	ABSENCE_DETAILS,
	ABSENCE_DETAILS_ERROR,
	ABSENCE_DETAILS_SUCCESS,
	ABSENCE_DELETE,
	ABSENCE_DELETE_ERROR,
	ABSENCE_DELETE_SUCCESS,
	ABSENCES_LIST,
	ABSENCES_LIST_SUCCESS,
	ABSENCES_LIST_ERROR
} from "../actions/absences";
import {
	MENU_ITEMS
} from "../actions/roles";
import Vue from "vue";
import AbsencesService from '@/services/absences';

const state = {
	status: '',
	absence: {},
	absences: []
};

const getters = {
	getAbsence: state => state.absence,
	isAbsenceLoaded: state => !!state.absence.user_id,
	getAbsences: state => state.absences
};

const actions = {
	[ABSENCE_CREATE_EDIT]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.modalAbsence.id,
			userId: data.modalAbsence.user_id,
			startDate: data.modalAbsence.start_date,
			endDate: data.modalAbsence.end_date,
			reason: data.modalAbsence.reason,
			note: data.modalAbsence.note,
			tasksAction: data.modalAbsence.tasks_action,
			replacementUserId: data.modalAbsence.replacement_user_id,
		}
		return new Promise((resolve, reject) => {
			commit(ABSENCE_CREATE_EDIT);
			AbsencesService.createEdit(requestData).then(responseData => {
				commit(ABSENCE_CREATE_EDIT_SUCCESS);
				dispatch(ABSENCE_DETAILS, responseData.absence.id);
				resolve(responseData);
			})
			.catch(error => {
				commit(ABSENCE_CREATE_EDIT_ERROR, error);
				reject(error);
			});
		});
	},
	[ABSENCE_DETAILS]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(ABSENCE_DETAILS);
			AbsencesService.details(requestData)
				.then(data => {
					commit(ABSENCE_DETAILS_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(ABSENCE_DETAILS_ERROR, error);
					reject(error);
				});
		});
	},
	[ABSENCE_DELETE]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(ABSENCE_DELETE);
			AbsencesService.delete(requestData)
				.then(data => {
					commit(ABSENCE_DELETE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(ABSENCE_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[ABSENCES_LIST]: ({ commit }, data) => {
		let requestData = {
			perPage: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.search) {
			requestData.search = data.tableProps.inputFilter.search;
		}
		if (data.tableProps.inputFilter.dateFrom) {
			requestData.dateFrom = data.tableProps.inputFilter.dateFrom;
		}
		if (data.tableProps.inputFilter.dateTo) {
			requestData.dateTo = data.tableProps.inputFilter.dateTo;
		}
		if (data.tableProps.inputFilter.reason) {
			requestData.reason = data.tableProps.inputFilter.reason;
		}
		return new Promise((resolve, reject) => {
			commit(ABSENCES_LIST);
			AbsencesService.list(requestData).then(absences => {
				commit(ABSENCES_LIST_SUCCESS, absences);
				resolve(absences);
			})
			.catch(error => {
				commit(ABSENCES_LIST_ERROR, error);
				reject(error);
			});
		});
	}
};

const mutations = {
	[ABSENCE_CREATE_EDIT]: state => {
		state.status = 'loading';
	},
	[ABSENCE_CREATE_EDIT_SUCCESS]: (state) => {
		state.status = 'success';
	},
	[ABSENCE_CREATE_EDIT_ERROR]: state => {
		state.status = 'error';
	},
	[ABSENCE_DETAILS]: state => {
		state.status = 'loading';
	},
	[ABSENCE_DETAILS_SUCCESS]: (state, details) => {
		state.status = 'success';
		Vue.set(state, 'absence', details);
	},
	[ABSENCE_DETAILS_ERROR]: state => {
		state.status = 'error';
	},
	[ABSENCE_DELETE]: state => {
		state.status = 'loading';
	},
	[ABSENCE_DELETE_SUCCESS]: (state) => {
		state.status = 'success';
	},
	[ABSENCE_DELETE_ERROR]: state => {
		state.status = 'error';
	},
	[ABSENCES_LIST]: state => {
		state.status = 'loading';
	},
	[ABSENCES_LIST_SUCCESS]: (state, absences) => {
		state.status = 'success';
		Vue.set(state, 'absences', absences);
	},
	[ABSENCES_LIST_ERROR]: state => {
		state.status = 'error';
		Vue.set(state, 'absences', null);
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};